export default __webpack_public_path__ + "static/media/210.986493a5.jpg";